const E = {
  ERROR: "error",
  WARNING: "warning",
  SUCCESS: "success"
}, e = {
  LARGE: "lg",
  EXTRA_LARGE: "xl"
}, s = {
  xs: "",
  sm: "",
  md: "",
  lg: "d-description--lg",
  xl: "d-description--xl"
}, t = {
  xs: "d-label--xs",
  sm: "d-label--sm",
  md: "",
  lg: "d-label--lg",
  xl: "d-label--xl"
}, a = {
  esc: "Esc",
  escape: "Escape",
  tab: "Tab",
  enter: "Enter",
  space: "Space",
  spacebar: "Spacebar",
  up: "Up",
  arrowup: "ArrowUp",
  left: "Left",
  arrowleft: "ArrowLeft",
  right: "Right",
  arrowright: "ArrowRight",
  down: "Down",
  arrowdown: "ArrowDown",
  home: "Home",
  end: "End"
}, r = E.ERROR, o = "dt", l = {
  VALIDATION_MESSAGE_TYPES: E,
  DESCRIPTION_SIZE_TYPES: e,
  DEFAULT_VALIDATION_MESSAGE_TYPE: r,
  DEFAULT_PREFIX: o
};
export {
  o as DEFAULT_PREFIX,
  r as DEFAULT_VALIDATION_MESSAGE_TYPE,
  s as DESCRIPTION_SIZE_MODIFIERS,
  e as DESCRIPTION_SIZE_TYPES,
  a as EVENT_KEYNAMES,
  t as LABEL_SIZE_MODIFIERS,
  E as VALIDATION_MESSAGE_TYPES,
  l as default
};
//# sourceMappingURL=index.js.map
